// Phase 2 - Supra Urgent organ types (extended beyond liver)
export const SUPRA_URGENT_ORGAN_TYPES = [
  {
    name: "Liver",
    value: "103",
  },
  {
    name: "Heart",
    value: "106",
  },
  {
    name: "Lung",
    value: "107",
  },
];

export const ALF_STATUS = [
  {
    name: "Pending Sotto Review",
    value: "1",
  },
  {
    name: "Requested Supra Urgent Review",
    value: "2",
  },
  {
    name: "Approved",
    value: "3",
  },
  {
    name: "Deleted",
    value: "4",
  },
  {
    name: "Rejected",
    value: "5",
  },
  {
    name: "Delisted",
    value: "6",
  },
  {
    name: "Utilized",
    value: "7",
  },
];

export const ALF_REQUEST_STATUS = [
  {
    name: "Requested Supra Urgent Review",
    value: "0",
  },
  {
    name: "Approved",
    value: "1",
  },
  {
    name: "Rejected",
    value: "2",
  },
];
